import { AuthConfig } from '@auth0/auth0-angular';

const buildUrl = (baseUrl: string, ...parts: string[]) => [baseUrl, ...(parts ?? [])].join('/');

export const auth: AuthConfig = {
  authorizationParams: {
    audience: window.APP_CONFIG.AUTH0_COMMON_AUDIENCE,
    redirect_uri: buildUrl(window.APP_CONFIG.ASSESS_APP_URL, 'auth', 'callback'),
  },
  cacheLocation: (window.APP_CONFIG.AUTH0_WEB_CACHE_LOCATION || 'memory') as AuthConfig['cacheLocation'],
  clientId: window.APP_CONFIG.AUTH0_WEB_CLIENT_ID,
  domain: window.APP_CONFIG.AUTH0_COMMON_DOMAIN,
  useRefreshTokens: true,
  httpInterceptor: {
    allowedList: [
      buildUrl(window.APP_CONFIG.ASSESS_API_URL, '*'),
      buildUrl(window.APP_CONFIG.CHIMERA_API_URL, '*'),
      buildUrl(window.APP_CONFIG.DATA_MART_ADDRESS, '*'),
      buildUrl(window.APP_CONFIG.DATA_MART_SEARCH_ADDRESS, '*'),
      buildUrl(window.APP_CONFIG.WORKFLOW_ADDRESS, '*'),
      buildUrl(window.APP_CONFIG.CODE_SERVICE_ADDRESS, '*'),
    ],
  },
};
